import React, { Component } from 'react';
import {BrowserRouter as Router, Switch, Route, Redirect} from 'react-router-dom';
import Header from './components/header/header';
import Portfolio from './components/portfolio/portfolio';
import ContactUs from './components/contactus/contactus';
import Footer from './components/footer/footer';
import resumeData from './resumeData';
class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route path="/" exact>
            <div className="App">
              <Header resumeData={resumeData}/>
              <Portfolio resumeData={resumeData}/>
              <ContactUs resumeData={resumeData}/>
              <Footer resumeData={resumeData}/>
            </div>
          </Route>
          <Route path="/unity" component={() => {
            window.location.href = "https://linktr.ee/srini_unity";
            return null;
          }}/>
          <Route path="/crusade" component={() => {
            window.location.href = "https://linktr.ee/srini_crusade";
            return null;
          }}/>
          <Route path="/mailing-list-signup" component={() => {
            window.location.href = "https://linktr.ee/srinibass_";
            return null;
          }}/>
          <Route path="/crusade-presave" component={() => {
            window.location.href = "https://show.co/ShiSG49";
            return null;
          }}/>
          <Route>
            <Redirect to="/"/>
          </Route>
        </Switch>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js